import styled from 'styled-components';
import { margin } from 'styled-system';
import { TruncatedText } from '../Text/TruncatedText';
import { MarginProps } from '../../../theme/styledProps';

export const StyledSegmentedControl = styled.div(({ theme }) => ({
  background: theme.colors.neutral['100'],
  boxShadow: 'inset 0px 2px 4px rgba(55, 65, 81, 0.06)',
  borderRadius: theme.radii.medium,
  height: 44,
  padding: 4,
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.colors.neutral['300'],
  outline: 'none',
  userSelect: 'none',
  fontFamily: '"Inter", sans-serif',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  boxSizing: 'border-box',
  position: 'relative',

  '[data-whatinput="keyboard"] &:focus-within': {
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
    borderColor: theme.colors.primary['500'],
    zIndex: 1,
  },

  [`@media (min-width: ${theme.breakpoints[0]})`]: {
    height: 30,
    padding: 2,
  },
}));

export const Selection = styled.span(({ theme }) => ({
  display: 'flex',
  height: 34,
  top: 4,
  left: 4,
  background: theme.colors.bg,
  boxShadow: '0px 1px 2px rgba(55, 65, 81, 0.06), 0px 1px 3px rgba(55, 65, 81, 0.1)',
  borderRadius: theme.radii.medium,
  position: 'absolute',
  zIndex: 2,
  willChange: 'transform',
  cursor: 'pointer',

  [`@media (min-width: ${theme.breakpoints[0]})`]: {
    height: 24,
    top: 2,
    left: 2,
  },
}));

export const Option = styled.div(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  flex: 1,
  textAlign: 'center',
  height: '24px',

  label: {
    fontWeight: 600,
    fontSize: theme.fontSizes.small,
    lineHeight: theme.lineHeights.small,
    letterSpacing: theme.letterSpacings.wide,
    textTransform: 'uppercase',
  },

  input: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    padding: 0,
    margin: 0,
    appearance: 'none',
    outline: 'none',
    border: 'none',
    opacity: 0,
  },

  '&:not(:first-of-type)::before': {
    content: '""',
    display: 'inline-block',
    position: 'absolute',
    zIndex: 1,
    width: 1,
    height: 12,
    background: theme.colors.neutral['300'],
    left: -2,
    top: 6,
  },
}));

export const Value = styled(TruncatedText).attrs({
  letterSpacing: 'wide',
  fontWeight: 600,
  fontSize: 'small',
  textTransform: 'uppercase',
})<{ isSelected?: boolean }>(({ theme, isSelected }) => ({
  zIndex: 2,
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  cursor: 'pointer',
  color: isSelected ? theme.colors.primary['600'] : theme.colors.neutral['600'],
  transition: `color ${theme.transitions.normal}`,

  '&:hover': {
    color: isSelected ? theme.colors.primary['700'] : theme.colors.neutral['700'],
  },
}));

export const SegmentedControlShell = styled.div<MarginProps>(
  ({ theme }) => ({
    boxSizing: 'border-box',
    padding: '4px',
    background: theme.colors.bg,
    border: `1px solid ${theme.colors.neutral['300']}`,
    height: '30px',
    borderRadius: theme.radii.medium,
  }),
  margin,
);
